// extracted by mini-css-extract-plugin
export default {"portfolio":"portfolio__b539c014","banner":"banner__b539c014","banner_image":"banner_image__b539c014","content":"content__b539c014","description":"description__b539c014"};